import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';

export class ScholarshipManagementDto extends EpimsBaseEntityDto {
	@IsNotEmpty() ScholarshipManagementId: string;

	@IsNotEmpty() ScholarshipCategoryId: string;

	@IsNotEmpty() ScholarshipTypeId: string;

	@IsNotEmpty() BeneficarySurname: string;

	@IsNotEmpty() BeneficaryFirstname: string;

	@IsNotEmpty() BeneficaryOthername: string;

	@IsNotEmpty() ScholarshipDate: Date;

	@IsNotEmpty() ScholarshipAwardNo: string;

	@IsNotEmpty() ScholarshipApplicationNo: string;

	@IsNotEmpty() ScholarshipYear: string;

	@IsNotEmpty() Gender: string;

	@IsNotEmpty() DateOfBirth: string;

	@IsNotEmpty() Address: string;

	@IsNotEmpty() School: string;

	@IsNotEmpty() CourseOfStudy: string;

	@IsNotEmpty() ScholarshipAwardDurationId: string;

	@IsNotEmpty() State: string;

	@IsNotEmpty() LGA: string;

	Community: string;

	StudentPassport: string;

	@IsNotEmpty() SubscriberId: string;

	ScholarshipStatus: string;

	PhoneNumber: string;

	InstitutionCountryIdBeforeAward: string;

	InstitutionStateIdBeforeAward: string;

	InstitutionLGABeforeAward: string;

	InstitutionCommunityBeforeAward: string;

	ContactPerson: string;

	ContactPhoneNo: string;

  ContactEmail: string;

  ContactPersonOnAward: string;

	ContactPhoneNoOnAward: string;

  ContactEmailOnAward: string;

	ContactUrlOnAward: string;

	RemarksBeforeAward: string;

	InstitutionNameBeforeAward: string;

	InstitutionAddressBeforeAward: string;

	InstitutionNameOnAward: string;

	InstitutionAddressOnAward: string;

	InstitutionCountryIdOnAward: string;

	InstitutionStateIdOnAward: string;

	InstitutionLGAOnAward: string;

	InstitutionCommunityOnAward: string;

	RemarksOnAward: string;
}
